export default API => ({
    //活动列表
    activeList() {
        return API({
            url: `/gsyf/v1/study/get_activity_list`,
            method:'get'
        })
    },
    // 活动详情
    activeDetail(params) {
        return API({
            url: `/gsyf/v1/study/get_activity_content`,
            params,
            method:'get'
        })
    },
    // 查看满意度评价
    getEvaluate(params) {
        return API({
            url: `/gsyf/v1/study/get_mark`,
            params,
            method:'get'
        })
    },
    // 满意度评价
    evaluate(params,data) {
        return API({
            url: `/gsyf/v1/study/mark`,
            method:'post',
            params,
            data
        })
    },
})
  